import actions from './actions';

const initState = {
    product   : {},
    loading : false,
    errorMessage: null,
    message: null,
    status: null
};

export default function createOrUpdateProductReducer(state = initState, action) {
    switch (action.type) {
        case actions.CREATE_OR_UPDATE_PRODUCT_REQUESTED:
            return {
                ...state,
                product   : {},
                loading : true
            };
        case actions.CREATE_OR_UPDATE_PRODUCT_SUCCEEDED:

            return {
                ...state,
                product   : action.product,
                loading    : false
            };
        case actions.CREATE_OR_UPDATE_PRODUCT_FAILED:
            return {
                ...state,
                product   : {},
                loading : false,
                errorMessage: action.error?.message,
                message: action.error?.message,
                status: action.error?.status
            };
        default:
            return state;
    }
}
